import * as React from 'react';

import LayerTrigger, { Alignment } from 'components/LayerTrigger';
import Link from 'components/Link';
import Text from 'components/Text';
import Hovercard from 'components/Hovercard';
import HovercardBody from 'components/HovercardBody';

import './styles/SMSPreviewTooltip.scss';

const hovercard = (messageText: String) => (
  <Hovercard className="SMSPreviewTooltip">
    <HovercardBody>
      <Text color="thunder" size="xxsmall" weight="normal">
        SMS users will receive a preview and a link to see the full message.{' '}
        <Link>
          Learn more
      </Link>
      </Text>
      <div className="SMSPreviewTooltip-message">
        <Text size="small">
          {messageText}
          <div className="SMSPreviewTooltip-seeFullMessage">
            See full message: <Text color="brand">rmd.me/example-link</Text>
          </div>
        </Text>
      </div>
    </HovercardBody>
  </Hovercard>
)

const SMSPreviewTooltip = (props: {
  alignment?: Alignment;
  children?: React.ReactNode;
  text: String;
}) => (
    <LayerTrigger
      layer={hovercard(props.text)}
      alignment={props.alignment}
      delayShow={400}
      placement="top"
      trigger={['click']}>
      {props.children || null}
    </LayerTrigger>
  );

export default SMSPreviewTooltip;
